import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tooltip_22b80323__ from "@radix-ui/react-tooltip";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
function TooltipProvider({ delayDuration = 0, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tooltip_22b80323__.Provider, {
        "data-slot": "tooltip-provider",
        delayDuration: delayDuration,
        ...props
    });
}
function Tooltip({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipProvider, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tooltip_22b80323__.Root, {
            "data-slot": "tooltip",
            ...props
        })
    });
}
function TooltipTrigger({ className, children, underline = false, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tooltip_22b80323__.Trigger, {
        "data-slot": "tooltip-trigger",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(underline && "underline cursor-default decoration-dashed decoration-1 decoration-[#444444] underline-offset-[3px]", className),
        ...props,
        children: children
    });
}
function TooltipContent({ className, sideOffset = 8, children, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tooltip_22b80323__.Portal, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tooltip_22b80323__.Content, {
            "data-slot": "tooltip-content",
            sideOffset: sideOffset,
            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("rounded-md cursor-default border bg-grayscale-darker/30 py-1.5 px-2.5 z-[999999] text-[13px] text-white/90 backdrop-blur-xl", "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", "animate-in fade-in-0 zoom-in-95 origin-[var(--radix-tooltip-content-transform-origin)]", className),
            ...props,
            children: children
        })
    });
}
export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
